import _ from 'underscore'
var plugin = {
  key: 'vue-session-key',
  flash_key: 'vue-session-flash-key',
  setAll: function (all) {
    if (window.sessionStorage) {
      window.sessionStorage.setItem(plugin.key, JSON.stringify(all))
    } else {
      window._sessionStorage = window._sessionStorage || {}
      window._sessionStorage[plugin.key] = JSON.stringify(all)
    }
  }
}

plugin.install = function (Vue, options) {
  Vue.prototype.$session = {
    flash: {
      parent: function () {
        return Vue.prototype.$session
      },
      get: function (key) {
        var all = this.parent().getAll()
        var all_flash = all[plugin.flash_key] || {}

        var flash_value = all_flash[key]

        this.remove(key)

        return flash_value
      },
      set: function (key, value) {
        var all = this.parent().getAll()
        var all_flash = all[plugin.flash_key] || {}

        all_flash[key] = value
        all[plugin.flash_key] = all_flash

        plugin.setAll(all)
      },
      remove: function (key) {
        var all = this.parent().getAll()
        var all_flash = all[plugin.flash_key] || {}

        delete all_flash[key]

        all[plugin.flash_key] = all_flash
        plugin.setAll(all)
      }
    },
    getAll: function () {
      var all
      if (window.sessionStorage) {
        all = JSON.parse(window.sessionStorage.getItem(plugin.key))
      } else {
        all = JSON.parse(window._sessionStorage[plugin.key])
      }
      return all || {}
    },
    set: function () {
      var _set = (key, value) => {
        if (key == 'session-id') return false
        var all = this.getAll()
        if (!('session-id' in all)) {
          this.start()
          all = this.getAll()
        }
        all[key] = value
        plugin.setAll(all)
      }
      if (arguments.length == 1) {
        var o = arguments[0]
        _.each(o, (value, key) => {
          _set(key, value)
        })
      } else if (arguments.length == 2) {
        _set(arguments[0], arguments[1])
      }
    },
    get: function () {
      var all = this.getAll()
      if (arguments.length == 1) {
        return all[arguments[0]]
      } else {
        return _.pick(all, arguments)
      }
    },
    pick: function () {
      var all = this.getAll()
      var param = _.union([all], arguments)
      return _.pick.apply(_, param)
    },
    start: function () {
      var all = this.getAll()
      all['session-id'] = 'sess:' + Date.now()

      plugin.setAll(all)
    },
    exists: function () {
      var all = this.getAll()
      return 'session-id' in all
    },
    has: function (key) {
      var all = this.getAll()
      return key in all
    },
    remove: function (key) {
      var all = this.getAll()
      delete all[key]

      plugin.setAll(all)
    },
    clear: function () {
      var all = this.getAll()

      plugin.setAll({ 'session-id': all['session-id'] })
    },
    destroy: function () {
      plugin.setAll({})
    },
    id: function () {
      return this.get('session-id')
    }
  }
}
export default plugin
export const install = plugin.install
